const gameList = {
  code: 0,
  data: {
    gamelist: [
      {
        cate_name: "热血江湖",
        cate_id: "001"
      },
      {
        cate_name: "英雄无敌",
        cate_id: "002"
      },
      {
        cate_name: "小冰冰传奇",
        cate_id: "003"
      },
      {
        cate_name: "余烬风暴",
        cate_id: "004"
      }
    ]
  },
  message: 'success'
}

const serviceList = {
  code: 0,
  data: {
    servicelist: [
    {
      cate_name: "北美服务器",
      cate_id: "101"
    },
    {
      cate_name: "南美服务器",
      cate_id: "102"
    },
    {
      cate_name: "非洲服务器",
      cate_id: "103"
    },
    {
      cate_name: "澳洲服务器",
      cate_id: "104"
    }
    ]
  },
  message: 'success'
}

const roleList = {
  code: 0,
  data: {
    rolelist: [
      {
        cate_name: "小早川怜子",
        cate_id: "201"
      },
      {
        cate_name: "星咲优菜",
        cate_id: "202"
      },
      {
        cate_name: "北岛玲",
        cate_id: "203"
      },
      {
        cate_name: "西条琉璃",
        cate_id: "204"
      }
    ]
  },
  message: 'success'
}


export default {
  getGameList: () => {
    return gameList
  },
  getServiceList: () => {
    return serviceList
  },
  getRoleList: () => {
    return roleList
  }
};



// WEBPACK FOOTER //
// ./src/mock/exchange.js